import { useMemo } from 'react';
import { useMerklDappsCampaigns } from '../other/useMerklDappCampaigns';
import { useCoinGeckoTokenInfo } from '../useCoinGeckoTokenInfo';
import { useCampaignsWithTokenImage } from './useCampaignsWithTokenImage';
import { useTokenAddresses } from './useTokenAddresses';
import { useTokenImagesMap } from './useTokenImageMap';
import { combineCampaignsByPool } from './utils';

export const useDappInfo = ({ dappMerklId }: { dappMerklId?: number | string }) => {
  const { data: dappCampaignsInfo } = useMerklDappsCampaigns(dappMerklId);
  const tokenAddresses = useTokenAddresses(dappCampaignsInfo?.merkl_campaigns || []);
  const { data: coinGeckoTokensInfo } = useCoinGeckoTokenInfo(tokenAddresses);
  const tokenImagesMap = useTokenImagesMap(coinGeckoTokensInfo);
  const campaignsInfoWithTokenImage = useCampaignsWithTokenImage(dappCampaignsInfo, tokenImagesMap);

  const campaignsInfoTransformed = useMemo(
    () => combineCampaignsByPool(campaignsInfoWithTokenImage),
    [campaignsInfoWithTokenImage]
  );

  return {
    campaignInfo: campaignsInfoTransformed,
    dappCampaignsInfo,
  };
};
